module.exports = __webpack_public_path__ + "static/media/DINO.13aea5e3.png";